const TOURNAMENTS = [
    {
        imgUrl:"https://cdn.eslgaming.com/misc/media/india/Projects/dew-arena/dota-main-banner.jpg",
        title:"Dew Arena",
    },
    {
        imgUrl:"https://skyesports.in/assets/img/count.jpg",
        title:"Skyesports Championship",
    },
    {
        imgUrl:"https://cdn.eslgaming.com/misc/media/india/india/premiership2020/eslplay/winter/india-premiership-main-winter.jpg",
        title:"ESL India Premiership",
    },
    {
        imgUrl:"https://www.gosugamers.in/wp-content/uploads/2024/02/iQOO-India-League-BGMI-1-1024x576.jpg",
        title:"India League LAN Tournament (BGMI India League)",
    }
]

export {TOURNAMENTS}